module.exports = __webpack_public_path__ + "static/media/slide9.9a75f931.jpg";